import { Component, OnInit } from '@angular/core';
import { TemplateService } from '@app/services/template.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-template-list',
  templateUrl: './template-list.component.html',
  styleUrls: ['./template-list.component.scss']
})
export class TemplateListComponent implements OnInit {
  templates: any[] = [];

  constructor(private templateService: TemplateService, private router: Router) { }

  ngOnInit() {
    this.loadTemplates();
  }

  loadTemplates() {
    this.templateService.getTemplateList().subscribe(data => this.templates = data);
    console.log(this.templates, 'template list');

  }

  addTemplate() {
    this.router.navigate(['/designer/template-form']);
  }

  editProperties(template: any) {
    // debugger;
    this.router.navigate(['/designer/property-editor', template.MTShortCode]);

  }
}
